// import React from 'react';
// import partnerBanner from '../img/envision/automotivemobility/automotivebanner.JPG';

// const Automobilitybanner = () => {
//     return (
//         <div style={{ position: 'relative', height: '750px', width: '100%' }}>
//             {/* Text Overlay */}
//             <div
//                 style={{
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     height: '100%',
//                     width: '100%',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     color: '#fff',
//                     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                     zIndex: 1,
//                 }}
//             >
//                 <h1 style={{ margin: 0, textAlign: 'center' }}>Industries & Services - Automotive, Rail,<br></br> and Next-Gen Mobility</h1>
//             </div>

//             {/* Image */}
//             <img
//                 src={partnerBanner}
//                 alt="partner banner"
//                 style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
//             />
//         </div>
//     );
// };

// export default Automobilitybanner;




import React from 'react';
import partnerVideo from '../img/envision/automotivemobility/5497-184226939_small.mp4'; // Replace with the correct path to your video file

const Automobilitybanner = () => {
    return (
        <div style={{ position: 'relative', height: '750px', width: '100%' }}>
            {/* Text Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1,
                   flexDirection: 'column',
                }}
            >
                <h1 style={{ margin: 0, textAlign: 'center' }}>Driving the future of mobility with secure, intelligent,<br></br>  and connected IT-OT transformations</h1>
                {/* <p>Enabling Network Transformation and Empowering Autonomous Operations</p> */}
            </div>

            {/* Video */}
            <video
                src={partnerVideo}
                alt="partner video"
                autoPlay
                loop
                muted
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    objectFit: 'cover', // This will ensure the video covers the area without stretching
                }}
            />
        </div>
    );
};

export default Automobilitybanner;

